import { supersetDashboardsOps } from "../api/operations";
import { entityFactory } from "../hooks/useEntity";
import { ROLE } from "../Auth/useRole";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("bi-dashboards"),
  endpoint: "superset-dashboards",
  operations: supersetDashboardsOps,
  roleView: [ROLE.BI_DASHBOARD_RUN],
  roleAdmin: [ROLE.BI_DASHBOARD_RUN],
  baseRoute: "bi-dashboards",
  singularName: (t) => t("BI Dashboard"),
  name: (t) => t("BI Dashboard"),
  disableCache: true,
});

export default conf;
